const createMinMax = (unit) => {
    switch (unit) {
    case 'second':
        return [0, 60]
    case 'minute':
        return [1, 60]
    case 'hour':
        return [1, 12]
    case 'day':
        return [1, 5]
    case 'week':
        return [1, 5]
    case 'month':
        return [1, 12]
    case 'year':
        return [1, 9999]
    default:
        return [1, 99]
    }
}

/**
 * Determines a difference label based on two dates
 * @param {moment} endDate 
 * @param {moment} startDate 
 * @param {string} unit Units of measurement second|minute|hour|day
 * @param {number} min Minimum difference otherwise use defaultValue
 * @param {number} max Maximum difference otherwise use defaultValue
 * @param {string} defaultValue 
 */
const generateDifference = (endDate, startDate, unit, defaultValue = null) => {
    const duration = endDate.diff(startDate, `${unit}s`)
    const [min, max] = createMinMax(unit)
    const suffix = duration > 1 ? 's' :''
    return duration >= min && duration < max ? `${duration} ${unit}${suffix} ago` : defaultValue
}

export default generateDifference
